module.exports = __webpack_public_path__ + "static/media/gps.7b7a61a3.svg";